import React, { createContext, useState, useContext } from 'react';

export const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    email: '',
    address: '',
    city: '',
    postalCode: '',
    shippingFee: 0,  // shippingFee should be initialized here
    shippingAddress: {},
    shippingMethod: '',
  });

  const getTotalCartAmount = () => {
    return Object.values(cartItems).reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
  };

  // Function to update form data
  const updateFormData = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
    }));
  };

  const setShippingFee = (fee) => {
    setFormData((prevData) => ({
        ...prevData,
        shippingFee: fee, // Update the shipping fee
    }));
};


  // Function to set shipping method and automatically update the shipping fee
  const setShippingMethod = (method, fee) => {
    setFormData((prevData) => ({
      ...prevData,
      shippingMethod: method,
      shippingFee: fee,  // Also update the shippingFee when method is set
    }));
  };

  const value = {
    cartItems,
    setCartItems,
    formData,
    setFormData,
    shippingFee: formData.shippingFee,  // Shipping fee from formData
    getTotalCartAmount,
    updateFormData,
    setShippingMethod,  // Now setShippingMethod is available
  };

  return <OrderContext.Provider value={value}>{children}</OrderContext.Provider>;
};

export const useOrderContext = () => useContext(OrderContext);
